import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ShortText",
  "use": "svg-icon-ShortText-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-ShortText\"><path d=\"M15 3H1V1h14v2zm0 8H1V9h14v2zM1 7h8V5H1v2zm10 8H1v-2h10v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol